export interface AssignedUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  role: string;
}

export interface ModerationFlag {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
  icon: "sexual" | "hate" | "harassment" | "selfHarm" | "violence";
  assignedUserId: string | null;
}

// Available users
export const availableUsers: AssignedUser[] = [
  { id: "user-1", name: "Dr. Sarah Chen", email: "schen@university.edu", role: "Dean of Students" },
  { id: "user-2", name: "Marcus Williams", email: "mwilliams@university.edu", role: "Student Safety Officer" },
  { id: "user-3", name: "Dr. Emily Rodriguez", email: "erodriguez@university.edu", role: "Counseling Director" },
  { id: "user-4", name: "James Thompson", email: "jthompson@university.edu", role: "Title IX Coordinator" },
  { id: "user-5", name: "Dr. Aisha Patel", email: "apatel@university.edu", role: "VP Student Affairs" },
];

// Initial moderation settings
export const initialModerationSettings: ModerationFlag[] = [
  {
    id: "sexual",
    name: "Sexual Content",
    description: "Detection of explicit sexual content, references, and content involving minors",
    enabled: true,
    icon: "sexual",
    assignedUserId: null,
  },
  {
    id: "hate",
    name: "Hate & Discrimination",
    description: "Detection of hateful, discriminatory, or threatening content based on protected characteristics",
    enabled: true,
    icon: "hate",
    assignedUserId: null,
  },
  {
    id: "harassment",
    name: "Harassment",
    description: "Detection of harassing, bullying, or threatening content directed at individuals",
    enabled: true,
    icon: "harassment",
    assignedUserId: "user-2",
  },
  {
    id: "selfHarm",
    name: "Self-Harm",
    description:
      "Detection of self-harm related content, expressions of intent, or instructions - critical for student safety",
    enabled: true,
    icon: "selfHarm",
    assignedUserId: "user-3",
  },
  {
    id: "violence",
    name: "Violence",
    description: "Detection of violent content, threats, or graphic depictions of violence",
    enabled: true,
    icon: "violence",
    assignedUserId: "user-2",
  },
];
